// libraries
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Space from 'material/space/space';
import { Button, displayModal } from '@insticator/insticator-ui';
import { updateCurrentPage } from 'state/slices/app';
// styles
import injectSheet from "react-jss";
import styles from './unsavedchangeconfirmpopup_styles.js';


/* ========== ~~~~~~~~~~ UNSAVED CHANGE CONFIRM POPUP ~~~~~~~~~~ ========== */
const UnsavedProductManagerConfirmPopup = injectSheet(styles)(({ route }) => {

  const dispatch = useDispatch()

  const onProductManagerContinue = useCallback(async() => {
    dispatch(displayModal(false))
    dispatch(updateCurrentPage(route))
  }, [dispatch, route])

  const onStayPage = () => {
    dispatch(displayModal(false))
  }
  

  return (
    <Space direction={'column'} alignItems={'center'} justifyContent={'center'} style={{textAlign: 'center'}}>
      <h4 style={{marginTop: '24px'}}>You have unsaved changes</h4>
      <p style={{marginTop: '24px', width: '400px'}}>You are about to navigate away from the Product Manager page. Any unsaved changes will be lost</p>
      <Space style={{marginTop: '32px'}} alignItems={'center'} justifyContent={'center'}>
        <Button text='Continue without saving' variant='none' color='light' handleClick={onProductManagerContinue} />
        <Button text={'Stay on Current Page'} variant={'primary'} handleClick={onStayPage} />
      </Space>   
  </Space>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default UnsavedProductManagerConfirmPopup